<template>
  <div>
    <v-menu
      v-model="isOpenMenu"
      :close-on-content-click="false"
      :close-on-click="true"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn v-bind="attrs" :block="block" :color="color" v-on="on">
          <v-icon left v-if="!caption">mdi-calendar</v-icon>
          <div v-if="!caption">{{ formatDate(value) || "Selecione" }}</div>
          <div v-if="caption">{{ caption }}</div>
        </v-btn>
      </template>
      <v-card>
        <v-date-picker
          v-model="date"
          :allowed-dates="allowedDates"
          class="mt-4"
          no-title 
          locale="pt-br"
        ></v-date-picker>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="onClickApply()"> Aplicar </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "SelectDate",

  props: {
    value: {
      type: String,
      default: "",
    },
    caption: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "secondary",
    },
    blockOldDates: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpenMenu: false,
      date: this.value,
    };
  },

  methods: {
    allowedDates(date) {
      if (!this.blockOldDates) return true;

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Remove time part

      const selectedDate = new Date(date);
      selectedDate.setHours(0, 0, 0, 0); // Remove time part

      return selectedDate >= today;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    onClickApply() {
      this.$emit("input", this.date);
      this.$emit("click");
      this.isOpenMenu = false;
    },
  },
};
</script>